var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{'is-vertical': _vm.isVertical},attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.labelText)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }